
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta } from "/home/vsts/work/1/s/pages/index.vue?macro=true";
import { default as healthKC3Zv9Ya4Sp9Igk_45dmlZqEowTE3nfRBVUFQkb_45sxPuAMeta } from "/home/vsts/work/1/s/pages/health.vue?macro=true";
import { default as indexv8f19r1M2TUssORWNnY2k_45D70OFaZY9o9pDiXk_cX9UMeta } from "/home/vsts/work/1/s/pages/blog/index.vue?macro=true";
import { default as index_45EoVAZqDN8wD_45TzzMS_jIR5pLlct_zoyE8Z0Wt_lr4IMeta } from "/home/vsts/work/1/s/pages/gifts/index.vue?macro=true";
import { default as indexh9dBMpLVKAItUrjwyLOAQ4DtTL9zEQpN5OMGGQMm9ZkMeta } from "/home/vsts/work/1/s/pages/login/index.vue?macro=true";
import { default as index0Q3YcfyDG989H4Lqq2yfPpZAh30zf5QT__45jP32OjKWMMeta } from "/home/vsts/work/1/s/pages/how-to/index.vue?macro=true";
import { default as indexrD8ReY5tAng1b7iFTfXij782f_kUZ80qRXEnRQofsjcMeta } from "/home/vsts/work/1/s/pages/[contentType]/index.vue?macro=true";
import { default as indexu9E5dFpLHatFqdIPLG2yOpj8zvUeErthPJYZmklmXicMeta } from "/home/vsts/work/1/s/pages/[contentType]/[category]/index.vue?macro=true";
import { default as _91game_93aTiPpbcG5v52wsoYUlLBZF7xkCbBVYTsWmYxZWR8loAMeta } from "/home/vsts/work/1/s/pages/[contentType]/[category]/[game].vue?macro=true";
import { default as lucky_45numbers3bhdmRTAjTS47iH2jKkZIgJWrz2N7vbCe7SHqL7EVjgMeta } from "/home/vsts/work/1/s/pages/[contentType]/[category]/lucky-numbers.vue?macro=true";
import { default as _91category_938k3RyAf3l7KnoEGIVSr0kOPINCA_45JlLPpPE5nK2zAR8Meta } from "/home/vsts/work/1/s/pages/[contentType]/[category].vue?macro=true";
import { default as index4O4UV9LTF90H2Hw2uq5hjOq7s9_MTSSh3K7Z_JfE2JIMeta } from "/home/vsts/work/1/s/pages/[contentType]/demo-play/index.vue?macro=true";
import { default as indexXLgWPYLayP1hiujgo6BFPKS_V8Of3BZtiH0u_Ql8eycMeta } from "/home/vsts/work/1/s/pages/[contentType]/favorites/index.vue?macro=true";
import { default as indexrORU_JbuZjoYMmLcRCgcChigfm0ltDJHAt_45a1_45aZ_soMeta } from "/home/vsts/work/1/s/pages/[contentType]/providers/index.vue?macro=true";
import { default as _91provider_93_45d76oAqMBEj3A0yKdiVhUiieHJg7i52HMN_NQYulU_kMeta } from "/home/vsts/work/1/s/pages/[contentType]/providers/[provider].vue?macro=true";
import { default as indexYHC4iD47ZNm_45OnjlylwlyYJurIzR8QglBcogFtIxJW8Meta } from "/home/vsts/work/1/s/pages/[contentType]/recently-played/index.vue?macro=true";
import { default as _91contentType_93Q9_45qtzaoHMXGbH8bnfY7T99L41dM_icIl4nwdDudDI4Meta } from "/home/vsts/work/1/s/pages/[contentType].vue?macro=true";
import { default as indexTRwUsUJwb2_45Og1_EoJ1q3_45K23nbKSdc2QT3Yi_lsw6wMeta } from "/home/vsts/work/1/s/pages/landing/index.vue?macro=true";
import { default as indexYxdGXsm8itnN9pJ2N21dlu_45vz31vxTjJ6Uu3_45McC_2sMeta } from "/home/vsts/work/1/s/pages/partners/index.vue?macro=true";
import { default as indexhYr9A30ipoXVRRLc1THe31TljbG2rtMATi18Ws3NJTgMeta } from "/home/vsts/work/1/s/pages/register/index.vue?macro=true";
import { default as indexjf58DL47Xi1Dvuv7eh4im_3m3WGCK5qP8LOAVNPX5W0Meta } from "/home/vsts/work/1/s/pages/new-games/index.vue?macro=true";
import { default as indexHGDAYdkLN_YsZo1T9S2rl5JURNaeX78g_B23a4VrBYsMeta } from "/home/vsts/work/1/s/pages/promotions/index.vue?macro=true";
import { default as indexh8o3QevwyqndEDRNvdvMfAxueotTmtTwnr5xqa5_8hAMeta } from "/home/vsts/work/1/s/pages/get-the-app/index.vue?macro=true";
import { default as faqO9tC2OCMJD8UUcEq7Af3UhQFG9KwLdplMqoQ8rvuykYMeta } from "/home/vsts/work/1/s/pages/(footer-pages)/faq.vue?macro=true";
import { default as indexkEQcohC1rnQ5TdGIMNPiFnEHNDkJ_EQg3iauHS_2_REMeta } from "/home/vsts/work/1/s/pages/luckynumbers/index.vue?macro=true";
import { default as _91campaign_93nHafX94_4b0DnjdGTKwLLIIkEE4M_XWXhTge8FjUnLUMeta } from "/home/vsts/work/1/s/pages/campaigns/[campaign].vue?macro=true";
import { default as indexA_V9bb_459bZatt0hJ0Pte8TD1pXGsRG0Jfz3RYAv8yZUMeta } from "/home/vsts/work/1/s/pages/winners-circle/index.vue?macro=true";
import { default as index87XdboDpnxrwe6ItLcU_2tCtOyQKEr_KikAig5fQwMoMeta } from "/home/vsts/work/1/s/pages/blog/[category]/index.vue?macro=true";
import { default as index7j2pIIH_w_45x9hgKMcJQlneYD3uZPnm_45rvX_45BNv2T_45wEMeta } from "/home/vsts/work/1/s/pages/suggest-and-win/index.vue?macro=true";
import { default as _91post_93H_qWCd5sfdeeZsPQexvw9_45bNPvj68UarWJwnskT7p68Meta } from "/home/vsts/work/1/s/pages/blog/[category]/[post].vue?macro=true";
import { default as _91promotion_93yl9vGPhpD5Z9nzq_wuvQGa9svHkSUp4KIigTQqPc0jcMeta } from "/home/vsts/work/1/s/pages/promotions/[promotion].vue?macro=true";
import { default as index51agoUTvqgrZwslICMViEuJeau5k5144Smdkm3BC7jMMeta } from "/home/vsts/work/1/s/pages/partners/register/index.vue?macro=true";
import { default as playgroundAAvttVkeFSou3_ut_45IYOy39fngvwohYuV_HrZkj_45268Meta } from "/home/vsts/work/1/s/pages/(playgrounds)/playground.vue?macro=true";
import { default as indexKyAwI2BZ1My9TXbuIVcB5JN7CdofY71K71ntzFjgMCQMeta } from "/home/vsts/work/1/s/pages/blog/big-city-life/index.vue?macro=true";
import { default as privacy_45policy_45pQjw0l8I0XPJuC_c12nzvpbx8GFav_45Q045u7y8_KyQMeta } from "/home/vsts/work/1/s/pages/(footer-pages)/privacy-policy.vue?macro=true";
import { default as banner_45playgroundFrEc4muCM4dSrDdi38zPzQDD4rhzyy8z2l3X1H7AAJMMeta } from "/home/vsts/work/1/s/pages/(playgrounds)/banner-playground.vue?macro=true";
import { default as index1wsS3WuWfbSta1T5XUHSOll8T7_45t0h_1f3SZqbeziyYMeta } from "/home/vsts/work/1/s/pages/partners/streaming-academy/index.vue?macro=true";
import { default as terms_45and_45conditionscpni3CmYPQcDYTr8nOt0KIa0XFuM8iDrE2HPTYgodEcMeta } from "/home/vsts/work/1/s/pages/(footer-pages)/terms-and-conditions.vue?macro=true";
import { default as indexC3M2MzTSMrAAPc_EJGaPy8CpXCcw7sUSFeZXngCmm6UMeta } from "/home/vsts/work/1/s/pages/blog/big-city-life/[category]/index.vue?macro=true";
import { default as registerFALpBbgBKbO8c6cZ9MnXB64gJjSqTs4_uLYHY7iLtXEMeta } from "/home/vsts/work/1/s/pages/partners/streaming-academy/register.vue?macro=true";
import { default as indexOqRKX8M7TRVnvhmaaKgEKOoE0tmphf8BO6s9GFlixjoMeta } from "/home/vsts/work/1/s/pages/blog/big-city-life/[category]/[subcategory]/index.vue?macro=true";
import { default as _91post_93m6RBBjQpp8zminPFsuYu4_hOsPV7VnS5fu5byA9Oeh4Meta } from "/home/vsts/work/1/s/pages/blog/big-city-life/[category]/[subcategory]/[post].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "health",
    path: "/health",
    meta: healthKC3Zv9Ya4Sp9Igk_45dmlZqEowTE3nfRBVUFQkb_45sxPuAMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/health.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/home/vsts/work/1/s/pages/blog/index.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    component: () => import("/home/vsts/work/1/s/pages/gifts/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(indexh9dBMpLVKAItUrjwyLOAQ4DtTL9zEQpN5OMGGQMm9ZkMeta || {}), ...{"middleware":"auth-logged-in"} },
    alias: ["/sign-in"],
    component: () => import("/home/vsts/work/1/s/pages/login/index.vue")
  },
  {
    name: "how-to",
    path: "/how-to",
    component: () => import("/home/vsts/work/1/s/pages/how-to/index.vue")
  },
  {
    name: _91contentType_93Q9_45qtzaoHMXGbH8bnfY7T99L41dM_icIl4nwdDudDI4Meta?.name,
    path: "/:contentType()",
    component: () => import("/home/vsts/work/1/s/pages/[contentType].vue"),
    children: [
  {
    name: "contentType",
    path: "",
    component: () => import("/home/vsts/work/1/s/pages/[contentType]/index.vue")
  },
  {
    name: _91category_938k3RyAf3l7KnoEGIVSr0kOPINCA_45JlLPpPE5nK2zAR8Meta?.name,
    path: ":category()",
    component: () => import("/home/vsts/work/1/s/pages/[contentType]/[category].vue"),
    children: [
  {
    name: "contentType-category",
    path: "",
    component: () => import("/home/vsts/work/1/s/pages/[contentType]/[category]/index.vue")
  },
  {
    name: "contentType-category-game",
    path: ":game()",
    component: () => import("/home/vsts/work/1/s/pages/[contentType]/[category]/[game].vue")
  },
  {
    name: "contentType-category-lucky-numbers",
    path: "lucky-numbers",
    component: () => import("/home/vsts/work/1/s/pages/[contentType]/[category]/lucky-numbers.vue")
  }
]
  },
  {
    name: "contentType-demo-play",
    path: "demo-play",
    meta: {"middleware":"demo-play"},
    component: () => import("/home/vsts/work/1/s/pages/[contentType]/demo-play/index.vue")
  },
  {
    name: "contentType-favorites",
    path: "favorites",
    component: () => import("/home/vsts/work/1/s/pages/[contentType]/favorites/index.vue")
  },
  {
    name: "contentType-providers",
    path: "providers",
    component: () => import("/home/vsts/work/1/s/pages/[contentType]/providers/index.vue")
  },
  {
    name: "contentType-providers-provider",
    path: "providers/:provider()",
    component: () => import("/home/vsts/work/1/s/pages/[contentType]/providers/[provider].vue")
  },
  {
    name: "contentType-recently-played",
    path: "recently-played",
    component: () => import("/home/vsts/work/1/s/pages/[contentType]/recently-played/index.vue")
  }
]
  },
  {
    name: "landing",
    path: "/landing",
    component: () => import("/home/vsts/work/1/s/pages/landing/index.vue")
  },
  {
    name: "partners",
    path: "/partners",
    component: () => import("/home/vsts/work/1/s/pages/partners/index.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: { ...(indexhYr9A30ipoXVRRLc1THe31TljbG2rtMATi18Ws3NJTgMeta || {}), ...{"middleware":"auth-logged-in"} },
    alias: ["/sign-up"],
    component: () => import("/home/vsts/work/1/s/pages/register/index.vue")
  },
  {
    name: "new-games",
    path: "/new-games",
    component: () => import("/home/vsts/work/1/s/pages/new-games/index.vue")
  },
  {
    name: "promotions",
    path: "/promotions",
    component: () => import("/home/vsts/work/1/s/pages/promotions/index.vue")
  },
  {
    name: "get-the-app",
    path: "/get-the-app",
    component: () => import("/home/vsts/work/1/s/pages/get-the-app/index.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/home/vsts/work/1/s/pages/(footer-pages)/faq.vue")
  },
  {
    name: "luckynumbers",
    path: "/luckynumbers",
    component: () => import("/home/vsts/work/1/s/pages/luckynumbers/index.vue")
  },
  {
    name: "campaigns-campaign",
    path: "/campaigns/:campaign()",
    meta: {"middleware":"auth-logged-in"},
    component: () => import("/home/vsts/work/1/s/pages/campaigns/[campaign].vue")
  },
  {
    name: "winners-circle",
    path: "/winners-circle",
    meta: indexA_V9bb_459bZatt0hJ0Pte8TD1pXGsRG0Jfz3RYAv8yZUMeta || {},
    alias: ["/winners"],
    component: () => import("/home/vsts/work/1/s/pages/winners-circle/index.vue")
  },
  {
    name: "blog-category",
    path: "/blog/:category()",
    component: () => import("/home/vsts/work/1/s/pages/blog/[category]/index.vue")
  },
  {
    name: "suggest-and-win",
    path: "/suggest-and-win",
    component: () => import("/home/vsts/work/1/s/pages/suggest-and-win/index.vue")
  },
  {
    name: "blog-category-post",
    path: "/blog/:category()/:post()",
    component: () => import("/home/vsts/work/1/s/pages/blog/[category]/[post].vue")
  },
  {
    name: "promotions-promotion",
    path: "/promotions/:promotion()",
    component: () => import("/home/vsts/work/1/s/pages/promotions/[promotion].vue")
  },
  {
    name: "partners-register",
    path: "/partners/register",
    meta: { ...(index51agoUTvqgrZwslICMViEuJeau5k5144Smdkm3BC7jMMeta || {}), ...{"middleware":"auth-logged-in"} },
    alias: ["/partners/sign-up","/partners/signup"],
    component: () => import("/home/vsts/work/1/s/pages/partners/register/index.vue")
  },
  {
    name: "playground",
    path: "/playground",
    component: () => import("/home/vsts/work/1/s/pages/(playgrounds)/playground.vue")
  },
  {
    name: "blog-big-city-life",
    path: "/blog/big-city-life",
    meta: { ...(indexKyAwI2BZ1My9TXbuIVcB5JN7CdofY71K71ntzFjgMCQMeta || {}), ...{"middleware":"big-city-life"} },
    alias: ["/big-city-lights"],
    component: () => import("/home/vsts/work/1/s/pages/blog/big-city-life/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/home/vsts/work/1/s/pages/(footer-pages)/privacy-policy.vue")
  },
  {
    name: "banner-playground",
    path: "/banner-playground",
    component: () => import("/home/vsts/work/1/s/pages/(playgrounds)/banner-playground.vue")
  },
  {
    name: "partners-streaming-academy",
    path: "/partners/streaming-academy",
    component: () => import("/home/vsts/work/1/s/pages/partners/streaming-academy/index.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    component: () => import("/home/vsts/work/1/s/pages/(footer-pages)/terms-and-conditions.vue")
  },
  {
    name: "blog-big-city-life-category",
    path: "/blog/big-city-life/:category()",
    meta: { ...(indexC3M2MzTSMrAAPc_EJGaPy8CpXCcw7sUSFeZXngCmm6UMeta || {}), ...{"middleware":"big-city-life"} },
    alias: ["/blog/big-city-lights/:category()"],
    component: () => import("/home/vsts/work/1/s/pages/blog/big-city-life/[category]/index.vue")
  },
  {
    name: "partners-streaming-academy-register",
    path: "/partners/streaming-academy/register",
    meta: registerFALpBbgBKbO8c6cZ9MnXB64gJjSqTs4_uLYHY7iLtXEMeta || {},
    alias: ["/partners/streaming-academy/sign-up","/partners/streaming-academy/signup"],
    component: () => import("/home/vsts/work/1/s/pages/partners/streaming-academy/register.vue")
  },
  {
    name: "blog-big-city-life-category-subcategory",
    path: "/blog/big-city-life/:category()/:subcategory()",
    meta: { ...(indexOqRKX8M7TRVnvhmaaKgEKOoE0tmphf8BO6s9GFlixjoMeta || {}), ...{"middleware":"big-city-life"} },
    alias: ["/blog/big-city-lights/:category()/:subcategory()"],
    component: () => import("/home/vsts/work/1/s/pages/blog/big-city-life/[category]/[subcategory]/index.vue")
  },
  {
    name: "blog-big-city-life-category-subcategory-post",
    path: "/blog/big-city-life/:category()/:subcategory()/:post()",
    meta: { ...(_91post_93m6RBBjQpp8zminPFsuYu4_hOsPV7VnS5fu5byA9Oeh4Meta || {}), ...{"middleware":"big-city-life"} },
    alias: ["/blog/big-city-lights/:category()/:subcategory()/:post()"],
    component: () => import("/home/vsts/work/1/s/pages/blog/big-city-life/[category]/[subcategory]/[post].vue")
  }
]